export type indicesDataChapitre1 = {
    hint: string;
    cardNumber: number[];
};

export type indicesDataChapitre2 = {
    hint: string;
    cardNumber: number[];
};

export const indicesDataChapitre1 = [
    {
        hint: 'Les inscriptions sur <span class="bold">le côté des cubes</span> semblent former <span class="bold">une lettre</span>.',
        cardNumbers: [1, 2, 3],
    },
    {
        hint: 'Le microscope pourrait servir à identifier cette <span class="bold">seconde protéine</span>.',
        cardNumbers: [4],
    },
    {
        hint: 'Sous le microscope, il faudrait identifier <span class="bold">B. Pertussis</span> parmi ses bactéries.',
        cardNumbers: [5],
    },
    {
        hint: 'Qui dit tétine dit .... ?',
        cardNumbers: [7],
    },
    {
        hint: '<span class="bold">Emma Relle</span> peut nous aider à analyser les données compilées par <span class="bold">Habib Rond</span>.',
        cardNumbers: [8, 40],
    },
    {
        hint: '<span class="bold">Habib Rond</span> est très réconnaissant vers le directeur de la FBI, Icare Nedsantais.',
        cardNumbers: [9, 25],
    },
    {
        hint: 'Il faudrait grimper pour attraper ces cookies.',
        cardNumbers: [10],
    },
    {
        hint: 'La seconde protéine <span class="bold">FIM2</span> permet de compléter le schéma de <span class="bold">B. pertussis</span>.',
        cardNumbers: [11],
    },
    {
        hint: 'Je vais enfin pouvoir déguster ce biberon !',
        cardNumbers: [12],
    },
    {
        hint: 'On dirait que les bactéries forment <span class="bold">un nombre</span> !',
        cardNumbers: [13, 14, 16, 17],
    },
    {
        hint: '<span class="bold">Emma Relle</span> va pouvoir aider maintenant !',
        cardNumbers: [15],
    },
    {
        hint: '<span class="bold">La clé de lecture</span> de ces graphiques doit être gardée dans un <span class="bold">endroit sécurisé</span>.',
        cardNumbers: [18, 21],
    },
    {
        hint: 'Il faudrait analyser le nombre de cas de <span class="bold">coqueloche</span> et d\'infections à <span class="bold">Hib</span>.',
        cardNumbers: [19, 20, 28],
    },
    {
        hint: 'Il faut repérer la bactérie <span class="bold">B. Pertussis</span> parmi tous les organismes qui se sont glissés dans l\'échantillon.',
        cardNumbers: [22, 27],
    },
    {
        hint: '<span class="bold">Habib Rond</span> a dû laisser des indices dans son bureau pour me permettre <span class="bold">d\'ouvrir son coffre</span>.',
        cardNumbers: [23, 29],
    },
    {
        hint: '<span class="bold">Un peu de courage</span> ...</br>Ce n\'est qu\'un mauvais moment à passer&nbsp;!',
        cardNumbers: [24],
    },
    {
        hint: '<span class="bold">Emma Relle</span> va pouvoir apporter son analyse&nbsp;!',
        cardNumbers: [26],
    },
    {
        hint: 'Il me faudrait une <br/> <span class="bold">clé de lecture</span> pour déchiffrer ces graphiques !',
        cardNumbers: [31, 33],
    },
    {
        hint: 'L\'objectif donné par <span class="bold">Habib</span> : découvrir comment fonctionnent <span class="bold">les deux vaccins&nbsp;</span>!',
        cardNumbers: [34, 42],
    },
    {
        hint: '<span class="bold">La clé</span> pourrait servir à lire les graphiques.',
        cardNumbers: [32, 85],
    },
    {
        hint: 'Ces biscuits vont calmer le gardien.',
        cardNumbers: [35, 81],
    },
    {
        hint: ' Parfois il faut juste suivre les consignes&nbsp;!',
        cardNumbers: [37, 41, 47],
    },
    {
        hint: 'On dirait qu\'il y a quelque chose au <span class="bold">fond du biberon</span>&nbsp;!',
        cardNumbers: [38],
    },
    {
        hint: 'Parfois il faut juste <br/><span class="bold">suivre les consignes</span>.',
        cardNumbers: [42],
    },
    {
        hint: '<span class="bold">Quel vacarme !</span> <br/>Il faudrait pourtant s\'approcher.',
        cardNumbers: [45],
    },
    {
        hint: '<span class="bold">Le garde</span> semble avoir faim ...<br/> Il faudrait lui apporter<span class="bold"><br/>un gouter</span>.',
        cardNumbers: [46],
    },
    {
        hint: 'L\'ordinateur et le microscope d\'<span class="bold">Emma</span> doivent receler des <span class="bold">informations importantes</span>.',
        cardNumbers: [48],
    },
    {
        hint: 'Il faut associer<br/> <span class="bold">la bactérie</span> à<br/><span class="bold">un vaccin</span>.',
        cardNumbers: [65, 70, 71, 72],
    },
    {
        hint: '<span class="bold">Emma Relle</span> a besoin de l\'identification des deux protéines.',
        cardNumbers: [52],
    },
    {
        hint: 'Oh on dirait une lettre !',
        cardNumbers: [55, 56],
    },
    {
        hint: 'Les visuels des isolats qu\'<span class="bold">Emma</span> tient en main pourront aider.',
        cardNumbers: [63],
    },
    {
        hint: 'Enfin les biscuits !',
        cardNumbers: [64],
    },
    {
        hint: 'Dans quel<span class="bold">ordre</span> utiliser ces objets pour<span class="bold">atteindre les biscuits ?</span>',
        cardNumbers: [66, 68, 69],
    },
    // {
    //     hint: '<span class="bold">Le gardien</span> ne laisse entrer personne <span class="bold">sans répondre</span> à ses questions.',
    //     cardNumbers: [81],
    // },
    {
        hint: 'Le rapport d\'<span class="bold">Emma</span> devrait nous permettre de <span class="bold">prendre du recul</span> vis-à-vis de nos découvertes.',
        cardNumbers: [89],
    },
    {
        hint: 'Merci <span class="bold">Emma</span> pour cette analyse&nbsp;!',
        cardNumbers: [99],
    },
];

/* TODO : Ajouter la liste d'indices du chapitre 2 ici */
export const indicesDataChapitre2 = [
    {
        hint: 'Les inscriptions sur <span class="bold">le côté des cubes</span> semblent former <span class="bold">une lettre</span>.',
        cardNumbers: [1, 2, 3],
    },
];
